










































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { ListItem, SkeletonBox } from '@/layouts/components'

import { Invoice, Order } from '@/models'

import OrderStatusChip from './OrderStatusChip.vue'
import RelativeTime from './RelativeTime.vue'

@Component({
  components: {
    ListItem,
    OrderStatusChip,
    RelativeTime,
    SkeletonBox
  }
})
export default class OrderTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly order!: Order

  @Prop({ type: Boolean, default: false })
  readonly relativeTime!: boolean

  get invoice (): Invoice | null {
    return this.invoiceById(this.order.invoiceId)
  }

  get locations () {
    return this.orderLocations(this.order)
  }

  @Getter('ordering/invoiceById')
  readonly invoiceById!: (id: number) => Invoice | null

  @Getter('ordering/orderLocations')
  readonly orderLocations!: (order: Order) => string[] | null
}
